import {
  AlertTriangle,
  ArrowRight,
  Check,
  ChevronLeft,
  ChevronRight,
  Command,
  CreditCard,
  File,
  FileText,
  HelpCircle,
  Image,
  Laptop,
  Loader2,
  LucideProps,
  Moon,
  MoreVertical,
  Pizza,
  Plus,
  Settings,
  SunMedium,
  Trash,
  Twitter,
  User,
  X,
  type Icon as LucideIcon,
} from "lucide-react";
import Link from "next/link";

export type Icon = typeof LucideIcon;

export const Icons = {
  logo: (props: LucideProps) => (
    // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    //   <path
    //     fill="currentColor"
    //     d="M11.572 0c-.176 0-.31.001-.358.007a19.76 19.76 0 0 1-.364.033C7.443.346 4.25 2.185 2.228 5.012a11.875 11.875 0 0 0-2.119 5.243c-.096.659-.108.854-.108 1.747s.012 1.089.108 1.748c.652 4.506 3.86 8.292 8.209 9.695.779.25 1.6.422 2.534.525.363.04 1.935.04 2.299 0 1.611-.178 2.977-.577 4.323-1.264.207-.106.247-.134.219-.158-.02-.013-.9-1.193-1.955-2.62l-1.919-2.592-2.404-3.558a338.739 338.739 0 0 0-2.422-3.556c-.009-.002-.018 1.579-.023 3.51-.007 3.38-.01 3.515-.052 3.595a.426.426 0 0 1-.206.214c-.075.037-.14.044-.495.044H7.81l-.108-.068a.438.438 0 0 1-.157-.171l-.05-.106.006-4.703.007-4.705.072-.092a.645.645 0 0 1 .174-.143c.096-.047.134-.051.54-.051.478 0 .558.018.682.154.035.038 1.337 1.999 2.895 4.361a10760.433 10760.433 0 0 0 4.735 7.17l1.9 2.879.096-.063a12.317 12.317 0 0 0 2.466-2.163 11.944 11.944 0 0 0 2.824-6.134c.096-.66.108-.854.108-1.748 0-.893-.012-1.088-.108-1.747-.652-4.506-3.859-8.292-8.208-9.695a12.597 12.597 0 0 0-2.499-.523A33.119 33.119 0 0 0 11.573 0zm4.069 7.217c.347 0 .408.005.486.047a.473.473 0 0 1 .237.277c.018.06.023 1.365.018 4.304l-.006 4.218-.744-1.14-.746-1.14v-3.066c0-1.982.01-3.097.023-3.15a.478.478 0 0 1 .233-.296c.096-.05.13-.054.5-.054z"
    //   />
    // </svg>

    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="100%"
      height="100%"
      viewBox="100 175 262 102"
    >
      <path
        fill="#C5AB4C"
        opacity="1.000000"
        stroke="none"
        d="
M149.487518,178.330963 
	C168.212799,172.891937 184.648102,176.410477 198.220963,189.953430 
	C207.747940,199.459412 211.755203,211.223602 211.154449,224.975128 
	C210.372650,242.870911 202.221634,256.439484 186.770813,264.008331 
	C160.559204,276.848511 131.730072,267.426605 120.747635,238.842896 
	C111.158127,213.884521 124.557884,187.616577 149.487518,178.330963 
M181.658035,257.161255 
	C185.523575,254.742691 189.389130,252.324127 193.254669,249.905563 
	C192.873657,249.139816 192.492645,248.374069 192.111633,247.608322 
	C189.966599,248.439468 187.388809,248.787735 185.786072,250.224014 
	C183.782242,252.019775 182.580231,254.710266 180.713135,257.139008 
	C180.786331,257.071350 180.859528,257.003662 181.658035,257.161255 
M150.927826,205.125717 
	C146.529129,205.948639 144.228836,211.032211 145.124146,218.577744 
	C149.329346,218.577744 153.609634,218.702591 157.872269,218.483612 
	C158.850189,218.433380 160.352905,217.376541 160.621109,216.484436 
	C163.051849,208.398529 160.583023,205.121780 152.306076,205.122559 
	C152.140427,205.122574 151.974777,205.122742 150.927826,205.125717 
M182.486969,206.857574 
	C178.201920,206.069290 173.916885,205.280991 169.251862,204.422791 
	C169.251862,209.889084 169.251862,213.950241 169.251862,218.168091 
	C174.623978,218.168091 179.662521,218.168091 185.561584,218.168091 
	C184.548691,214.252579 183.689499,210.931229 182.486969,206.857574 
M152.537064,226.829941 
	C149.938309,226.829941 147.339569,226.829941 144.672531,226.829941 
	C146.408401,242.035660 146.818329,240.742599 160.317978,239.289917 
	C160.317978,235.271149 160.317978,231.250244 160.317978,226.829865 
	C157.750900,226.829865 155.615631,226.829865 152.537064,226.829941 
M179.968277,239.984573 
	C185.197372,237.076706 183.995636,231.892166 185.103851,227.208313 
	C179.430923,227.208313 174.406677,227.208313 169.329224,227.208313 
	C169.329224,231.614761 169.329224,235.636826 169.329224,240.000702 
	C172.834122,240.000702 175.954880,240.000702 179.968277,239.984573 
M131.954376,205.154922 
	C126.822083,208.084579 127.580078,213.316116 126.255936,218.268341 
	C129.834015,218.268341 132.730042,218.268341 135.740967,218.268341 
	C136.626740,213.834015 137.451309,209.706039 138.365051,205.131638 
	C136.052917,205.131638 134.408188,205.131638 131.954376,205.154922 
M192.188995,205.279922 
	C192.349792,207.561935 192.269760,209.892197 192.715576,212.117111 
	C194.180405,219.427658 194.773056,219.713806 202.642258,217.901184 
	C203.052780,208.521500 200.448715,205.080475 192.188995,205.279922 
M195.846695,226.860840 
	C195.023010,227.496521 193.668625,227.997330 193.466873,228.791092 
	C192.560806,232.355881 191.982330,236.003937 191.281326,239.644592 
	C200.130310,240.501434 203.113434,237.127670 202.515091,226.837418 
	C200.622025,226.837418 198.678665,226.837418 195.846695,226.860840 
M132.437180,226.834366 
	C130.532990,226.834366 128.628815,226.834366 126.678261,226.834366 
	C127.547554,239.147507 129.168015,240.881561 138.191971,239.446411 
	C137.465759,235.754440 136.857269,232.031784 135.910248,228.397324 
	C135.729080,227.702072 134.214066,227.354385 132.437180,226.834366 
M137.732010,248.195862 
	C137.877121,249.054276 137.710876,250.289841 138.218613,250.709030 
	C141.190643,253.162735 144.320328,255.425476 147.836700,258.085388 
	C146.427856,251.602463 143.123627,248.315155 137.732010,248.195862 
M182.272903,190.375626 
	C187.736389,197.445679 187.736389,197.445679 193.551971,195.994888 
	C189.707336,193.243423 186.427505,190.879211 183.090042,188.599350 
	C183.000916,188.538483 182.287064,189.392166 182.272903,190.375626 
M142.494217,190.987640 
	C140.484650,192.692154 138.475067,194.396652 135.834213,196.636627 
	C142.904434,197.236801 145.916855,194.793732 147.464279,188.000763 
	C145.852951,188.957138 144.466293,189.780167 142.494217,190.987640 
M157.516891,254.010773 
	C158.401138,254.563400 159.285400,255.116028 160.434845,255.834381 
	C160.434845,253.051880 160.434845,250.824997 160.434845,248.492249 
	C157.871384,248.492249 155.695221,248.492249 153.294312,248.492249 
	C153.612015,249.363358 153.667496,249.900772 153.956589,250.237854 
	C154.927643,251.370178 155.981964,252.431076 157.516891,254.010773 
M160.738144,190.698456 
	C157.609802,190.295593 155.517288,192.116455 153.782379,196.663971 
	C155.956848,196.663971 158.174896,196.663971 160.797974,196.663971 
	C160.797974,194.663300 160.797974,193.044022 160.738144,190.698456 
M172.225357,253.817551 
	C173.602432,252.163666 174.979507,250.509781 176.602402,248.560669 
	C173.580231,248.560669 171.398285,248.560669 169.285141,248.560669 
	C169.285141,251.164474 169.285141,253.327255 169.285141,256.040161 
	C170.429413,255.211929 171.058640,254.756485 172.225357,253.817551 
M171.560699,191.080368 
	C170.937073,190.647354 170.313446,190.214340 169.223358,189.457428 
	C169.223358,192.226273 169.223358,194.384659 169.223358,196.682190 
	C171.655624,196.682190 173.802002,196.682190 175.948395,196.682190 
	C176.471832,196.053375 176.995255,195.424545 177.518692,194.795731 
	C175.692825,193.717377 173.866943,192.639023 171.560699,191.080368 
z"
      />
      <path
        fill="#BFA64C"
        opacity="1.000000"
        stroke="none"
        d="
M261.583069,239.521149 
	C259.635132,239.733551 257.687195,239.945953 255.467148,240.188034 
	C254.937912,235.460266 254.447891,231.082748 253.957870,226.705231 
	C253.705032,226.620636 253.452194,226.536026 253.199371,226.451416 
	C251.916000,229.976059 250.757324,233.554199 249.280228,236.995712 
	C248.776718,238.168808 247.472488,238.998230 246.534119,239.984711 
	C245.703247,239.086746 244.561325,238.324417 244.099533,237.265488 
	C242.685242,234.022400 241.532135,230.665436 239.390656,227.457275 
	C238.871948,231.526794 238.353241,235.596313 237.814941,239.819580 
	C235.928238,239.819580 234.310501,239.819580 231.999359,239.819580 
	C232.757492,230.977356 233.509964,222.201263 234.285019,213.161758 
	C245.541245,211.861771 241.928925,222.935883 246.706161,226.684113 
	C251.007965,222.886444 248.305862,212.479614 258.859558,212.838730 
	C259.653870,221.705551 260.416534,230.219299 261.405762,239.122742 
	C261.632294,239.512421 261.583069,239.521133 261.583069,239.521149 
z"
      />
      <path
        fill="#A4A4A4"
        opacity="1.000000"
        stroke="none"
        d="
M312.006226,222.051239 
	C312.006226,228.176514 312.006226,233.809097 312.006226,240.228821 
	C302.271698,239.516846 302.516724,229.563919 296.736176,225.032410 
	C296.451355,230.020081 296.183868,234.704071 295.897461,239.719650 
	C294.450958,239.831726 293.028229,239.941956 291.290466,240.076584 
	C291.290466,231.096069 291.290466,222.357361 291.290466,212.855148 
	C300.927582,213.240234 299.998657,223.927979 306.179901,227.675568 
	C306.484375,222.948349 306.785370,218.274918 307.107086,213.279938 
	C308.610413,213.173279 310.025116,213.072906 312.006226,212.932343 
	C312.006226,215.999130 312.006226,218.778854 312.006226,222.051239 
z"
      />
      <path
        fill="#BFA64C"
        opacity="1.000000"
        stroke="none"
        d="
M242.618256,250.235519 
	C247.006668,250.926651 251.001617,251.749786 256.089294,252.798065 
	C254.120071,255.462067 253.187836,256.723206 252.287170,257.941620 
	C244.629242,254.849487 241.740189,255.369171 239.614792,260.098755 
	C237.941330,263.822601 239.370346,268.975159 242.835556,270.505157 
	C246.401764,272.079773 249.257690,271.134003 250.713699,267.323242 
	C249.690598,264.650269 243.521515,268.154541 245.366669,262.248169 
	C249.000885,262.248169 252.746918,262.248169 256.477844,262.248169 
	C257.732483,270.225739 255.524734,274.254181 248.725388,276.555420 
	C243.588501,278.294006 236.411484,275.069122 233.629074,269.772156 
	C229.842743,262.563965 233.986832,253.208786 242.618256,250.235519 
z"
      />
      <path
        fill="#A4A4A4"
        opacity="1.000000"
        stroke="none"
        d="
M303.471008,252.189590 
	C309.787781,258.393677 310.834290,265.076050 306.810516,271.364929 
	C303.667572,276.277069 296.782593,277.996704 290.818604,275.359131 
	C285.038910,272.803131 281.961243,266.768036 283.538269,261.083038 
	C286.167969,251.603394 292.068848,248.877640 303.471008,252.189590 
M289.655792,264.350922 
	C289.988220,268.089661 291.685364,270.644531 295.682831,271.017517 
	C299.680298,271.390503 302.512482,268.833496 302.966095,264.576111 
	C303.443878,260.091888 301.099426,256.523071 297.330261,255.997040 
	C292.942596,255.384689 290.511627,257.749207 289.655792,264.350922 
z"
      />
      <path
        fill="#A3A3A3"
        opacity="1.000000"
        stroke="none"
        d="
M260.991272,268.926483 
	C260.991272,262.460999 260.991272,256.483887 260.991272,249.855316 
	C266.766449,250.600677 273.457703,247.714005 277.232361,254.065811 
	C279.725189,258.260681 278.179016,262.678864 273.493561,265.829224 
	C276.165283,269.333862 278.689606,272.645081 281.333923,276.113708 
	C278.191345,276.921478 278.191345,276.921478 267.263550,268.429626 
	C265.814941,271.535156 269.055054,277.884735 260.991272,276.811554 
	C260.991272,274.320343 260.991272,271.867584 260.991272,268.926483 
M271.413879,260.763031 
	C273.054871,256.758789 271.905457,254.836731 266.897400,255.243851 
	C267.906067,257.714233 263.815948,262.636719 271.413879,260.763031 
z"
      />
      <path
        fill="#A3A3A3"
        opacity="1.000000"
        stroke="none"
        d="
M362.394440,239.780060 
	C359.213013,240.079666 357.359100,239.919846 355.303101,236.761627 
	C354.158051,235.002670 345.503723,235.158249 344.670105,236.759964 
	C342.634338,240.671677 340.319946,239.956940 336.963135,239.802750 
	C340.095123,231.554077 343.031799,223.494446 346.297760,215.570526 
	C346.785461,214.387207 348.949738,213.023636 350.104675,213.207977 
	C351.536316,213.436447 353.346893,214.937775 353.914124,216.329330 
	C357.047241,224.015701 359.851501,231.836105 362.394440,239.780060 
M347.783173,229.196198 
	C349.268768,229.393661 350.754395,229.591141 353.014404,229.891541 
	C351.976440,226.979401 351.239014,224.910538 350.501617,222.841675 
	C350.129669,222.912735 349.757690,222.983810 349.385712,223.054871 
	C348.796295,224.879150 348.206909,226.703415 347.783173,229.196198 
z"
      />
      <path
        fill="#A3A3A3"
        opacity="1.000000"
        stroke="none"
        d="
M262.007324,239.721924 
	C261.583069,239.521133 261.632294,239.512421 261.620544,239.497681 
	C264.729889,231.909134 267.742584,224.287277 271.061981,216.801422 
	C271.739960,215.272537 273.561188,213.277954 274.870514,213.266769 
	C276.266541,213.254852 278.332489,215.060089 278.976501,216.557709 
	C282.197021,224.046356 285.046722,231.694489 288.177429,239.670273 
	C284.836884,239.951294 282.413666,241.027496 280.323761,236.728073 
	C279.581665,235.201401 270.514191,235.160172 269.705109,236.733398 
	C267.706268,240.620102 265.266052,239.907959 262.007324,239.721924 
M276.745911,229.640198 
	C276.440033,227.399734 276.134186,225.159256 275.828308,222.918793 
	C275.351318,222.961273 274.874329,223.003754 274.397339,223.046234 
	C273.730713,225.040344 273.064056,227.034439 272.269745,229.410385 
	C273.841034,229.565155 274.949890,229.674377 276.745911,229.640198 
z"
      />
      <path
        fill="#A4A4A4"
        opacity="1.000000"
        stroke="none"
        d="
M330.274963,274.241821 
	C325.944885,278.123810 321.249969,277.391937 317.154755,275.395660 
	C313.497650,273.613007 312.687347,269.697083 312.926147,265.558868 
	C313.212158,260.603546 312.993652,255.619110 312.993652,250.283783 
	C314.603394,250.169876 315.994843,250.071396 317.559174,249.960709 
	C318.006744,255.594681 318.139221,261.033478 319.033600,266.343994 
	C319.321655,268.054474 321.615997,269.427032 322.992523,270.954163 
	C324.341461,269.367249 326.563110,267.933899 326.874420,266.164459 
	C327.780701,261.013000 327.922485,255.727097 328.384735,250.249329 
	C329.774475,250.249329 331.165955,250.249329 333.179962,250.249329 
	C331.873840,258.233978 335.378662,266.449158 330.274963,274.241821 
z"
      />
      <path
        fill="#A6A6A6"
        opacity="1.000000"
        stroke="none"
        d="
M268.000946,199.807922 
	C268.000122,197.053589 268.000122,194.764175 268.000122,192.240753 
	C264.981598,192.240753 262.370026,192.240753 259.260742,192.240753 
	C259.260742,195.509705 259.260742,198.907562 259.260742,202.640457 
	C257.407288,202.802155 256.014862,202.923630 254.297546,203.073441 
	C254.297546,194.054688 254.297546,185.316620 254.297546,176.291595 
	C255.712173,176.291595 257.099243,176.291595 258.968567,176.291595 
	C258.968567,179.738144 258.968567,183.146545 258.968567,186.771698 
	C262.044189,186.771698 264.652679,186.771698 267.761719,186.771698 
	C267.761719,183.464874 267.761719,180.065903 267.761719,176.329636 
	C269.618286,176.188660 271.011047,176.082901 272.712524,175.953705 
	C272.712524,184.973816 272.712524,193.711548 272.712524,202.896835 
	C270.677155,202.626617 267.890045,204.540497 268.000946,199.807922 
z"
      />
      <path
        fill="#A4A4A4"
        opacity="1.000000"
        stroke="none"
        d="
M279.445984,202.532776 
	C279.115387,193.711548 279.115387,185.234726 279.115387,176.375824 
	C283.528107,176.375824 287.916779,176.375824 292.713501,176.375824 
	C292.810089,177.582458 292.920807,178.965561 293.013428,180.122681 
	C290.402313,182.751877 283.480499,177.966278 284.688507,185.319183 
	C284.869110,186.418503 288.816711,186.898941 291.604675,187.868423 
	C291.604675,188.607208 291.604675,190.114517 291.604675,191.617096 
	C289.127594,192.982224 284.021881,190.124680 284.460632,195.150726 
	C284.597626,196.719803 289.385651,197.882843 292.746643,199.587891 
	C292.746643,199.742569 292.746643,201.142105 292.746643,202.877213 
	C288.350555,202.877213 284.063568,202.877213 279.445984,202.532776 
z"
      />
      <path
        fill="#A4A4A4"
        opacity="1.000000"
        stroke="none"
        d="
M337.993774,255.104340 
	C337.993774,253.161850 337.993774,251.708237 337.993774,249.666916 
	C342.029327,250.016205 345.584930,250.213058 349.109558,250.656342 
	C353.799438,251.246185 355.931305,254.510773 355.887634,258.768158 
	C355.844574,262.962311 353.090210,266.226105 348.987915,266.330505 
	C342.495239,266.495789 342.552795,270.298767 342.983185,274.843506 
	C343.028320,275.320007 342.892517,275.813629 342.801056,276.670593 
	C341.436310,276.801758 340.036713,276.936279 337.993744,277.132660 
	C337.993744,269.762207 337.993744,262.677704 337.993774,255.104340 
M349.355194,257.070251 
	C347.676270,256.227692 345.997345,255.385101 343.684143,254.224213 
	C343.684143,257.563232 343.684143,259.616180 343.684143,261.784821 
	C347.223816,262.269806 349.706207,261.867676 349.355194,257.070251 
z"
      />
      <path
        fill="#A3A3A3"
        opacity="1.000000"
        stroke="none"
        d="
M320.117798,233.007721 
	C321.292328,233.316116 322.085999,233.944672 322.799683,233.864136 
	C324.815369,233.636597 326.798248,233.118240 328.794037,232.714478 
	C327.511841,231.251648 326.468872,229.418961 324.897736,228.402893 
	C321.617706,226.281631 317.871552,224.319641 319.163605,219.750351 
	C319.819885,217.429504 321.921417,214.510544 324.000153,213.851868 
	C326.637939,213.016052 329.935822,214.091827 332.898285,214.625366 
	C333.378418,214.711823 334.122955,216.672729 333.828400,217.048477 
	C333.136536,217.931091 331.942413,218.773941 330.856384,218.918579 
	C328.719147,219.203217 326.517273,219.002365 324.342163,219.002365 
	C324.166016,219.636658 323.989899,220.270950 323.813751,220.905228 
	C325.884064,222.286118 327.908661,223.742249 330.033417,225.033554 
	C335.989197,228.653152 337.092651,234.597229 332.396484,238.074753 
	C329.495422,240.223007 320.430939,240.392700 318.003113,237.886292 
	C315.971283,235.788681 316.663666,233.780991 320.117798,233.007721 
z"
      />
      <path
        fill="#C5AB4C"
        opacity="1.000000"
        stroke="none"
        d="
M246.735931,175.995560 
	C251.447800,175.805176 249.741364,178.574051 249.816055,180.799301 
	C247.896729,180.928986 246.273605,181.038651 244.187668,181.179581 
	C244.187668,188.219498 244.187668,195.284119 244.187668,202.670044 
	C242.015228,202.670044 240.298325,202.670044 238.104752,202.670044 
	C238.104752,195.669754 238.104752,188.607986 238.104752,181.200348 
	C235.930939,181.070145 234.196304,180.966248 232.243378,180.849258 
	C232.243378,179.209381 232.243378,177.820511 232.243378,175.994507 
	C237.038834,175.994507 241.652145,175.994507 246.735931,175.995560 
z"
      />
    </svg>

    //     <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
    // 	 width="100%" viewBox="0 0 180 180" enableBackground="new 0 0 180 180" >

    // <path fill="#00558F" opacity="1.000000" stroke="none"
    // 	d="
    // M165.813400,68.290672
    // 	C166.835907,69.287865 167.858414,70.285049 168.818146,71.949661
    // 	C158.935928,89.925224 145.369675,103.627335 128.264084,113.655251
    // 	C124.085960,116.104614 119.114944,117.639359 114.314034,118.467979
    // 	C109.298332,119.333664 104.232216,118.187492 101.260231,113.243317
    // 	C98.425163,108.526917 99.470451,103.880402 102.552162,99.760811
    // 	C104.419800,97.264183 106.553436,94.659523 109.159576,93.080528
    // 	C116.666222,88.532440 124.462730,84.460823 132.171219,80.249344
    // 	C133.863556,79.324745 135.662949,78.596115 137.413040,77.777237
    // 	C137.200165,77.118591 136.987289,76.459946 136.774414,75.801300
    // 	C127.914238,77.671043 118.900108,79.010612 110.228226,81.528763
    // 	C95.426559,85.826897 83.079834,94.445023 71.913506,104.943123
    // 	C63.875576,112.500023 54.596668,113.954086 44.234867,109.975548
    // 	C37.436962,107.365410 30.376314,105.446976 23.516975,102.985672
    // 	C20.879026,102.039116 18.472963,100.446327 15.961243,99.147987
    // 	C11.843068,90.419891 12.480662,87.393257 20.050398,83.066879
    // 	C24.159403,83.179810 27.997547,82.420898 30.844465,83.763626
    // 	C35.835865,86.117783 40.191444,89.803627 44.868313,92.847198
    // 	C47.698486,94.688988 50.632076,96.371864 53.747742,98.324020
    // 	C54.517124,98.388809 55.057964,98.255714 55.869595,98.138702
    // 	C56.442570,97.971375 56.744751,97.787964 57.207748,97.601578
    // 	C57.594051,97.479424 57.673107,97.296837 57.829914,96.673599
    // 	C57.892620,94.511482 58.052670,92.623245 57.517551,90.958450
    // 	C54.007702,80.038971 45.996925,73.536285 35.967228,68.807632
    // 	C32.343010,67.098938 29.226631,64.313072 25.878515,62.018749
    // 	C24.095057,56.576443 27.784147,50.849136 33.678989,50.085545
    // 	C35.470249,49.853516 37.312073,50.011829 39.885155,50.125702
    // 	C43.178425,51.534431 45.962593,52.478180 48.209869,54.145550
    // 	C54.808327,59.041298 58.573914,65.945747 61.495567,73.489296
    // 	C62.217564,75.353455 64.361885,76.666756 65.852371,78.233276
    // 	C67.231537,76.478500 68.610703,74.723724 70.131058,72.819550
    // 	C70.307938,72.534714 70.392418,72.390167 70.369225,72.265686
    // 	C70.320465,72.004097 70.215172,71.753052 70.273232,71.120056
    // 	C70.311066,68.352867 70.208755,65.963310 70.251907,63.375298
    // 	C70.286987,62.726406 70.176605,62.275955 70.100937,61.480278
    // 	C69.765076,60.086124 69.394501,59.037205 69.025589,57.653412
    // 	C68.699623,56.507301 68.372002,55.696060 68.043640,54.525978
    // 	C63.429016,47.418861 58.815125,40.670586 54.201237,33.922310
    // 	C54.246723,32.941509 54.701256,31.698256 54.268738,31.024153
    // 	C52.093792,27.634380 52.936714,24.361582 55.727245,22.483082
    // 	C58.383080,20.695255 61.952888,20.265148 65.805519,19.412050
    // 	C71.976532,21.181131 75.682304,24.998804 77.978104,29.910009
    // 	C80.274208,34.821877 81.543091,40.212334 83.816780,45.136978
    // 	C84.874092,47.427040 86.995049,49.543415 89.175163,50.797436
    // 	C89.800438,51.157101 92.775902,48.519699 93.882912,46.759197
    // 	C98.039001,40.149666 103.415779,35.342422 111.175636,33.545078
    // 	C112.033226,33.501183 112.890823,33.457287 114.316170,33.527401
    // 	C115.589554,33.748554 116.295189,33.855701 117.000816,33.962849
    // 	C117.000816,33.962849 117.013451,34.016464 117.128769,34.165070
    // 	C117.425049,34.532661 117.653305,34.607590 117.928856,34.538460
    // 	C118.095665,34.665928 118.262474,34.793400 118.833893,35.134361
    // 	C119.426476,35.568119 119.664726,35.665825 119.953239,35.640968
    // 	C123.405975,39.189980 126.788559,42.756824 122.660339,48.553467
    // 	C120.346466,49.673016 118.503059,50.371895 116.645988,51.032337
    // 	C109.107903,53.713154 102.412659,57.558239 97.856094,64.602066
    // 	C100.393829,64.524307 102.675835,63.787495 105.014412,63.360783
    // 	C108.351295,62.751919 111.799103,61.681541 115.078087,62.012299
    // 	C128.403122,63.356430 141.681808,65.160225 154.977585,66.794533
    // 	C157.952728,67.245995 160.927856,67.697456 164.464966,68.268440
    // 	C165.026917,68.387962 165.435669,68.464455 165.435669,68.464455
    // 	C165.435669,68.464455 165.813400,68.290672 165.813400,68.290672
    // z"/>
    // <path fill="#00558F" opacity="1.000000" stroke="none"
    // 	d="
    // M26.978462,139.018677
    // 	C25.641390,133.541321 29.592026,131.571136 33.369083,129.776077
    // 	C45.447487,124.035736 58.062069,123.897903 70.948570,126.342117
    // 	C80.062714,128.070831 89.184525,130.078461 98.397247,130.887802
    // 	C110.147346,131.920044 120.913872,128.010376 131.306686,122.602646
    // 	C136.193649,120.059799 141.669189,118.014076 147.074493,117.355408
    // 	C149.998245,116.999130 154.668259,119.277954 156.085068,121.769798
    // 	C157.328049,123.955917 156.068329,128.764557 154.291809,131.259918
    // 	C146.679413,141.952515 135.023254,146.016205 122.850304,148.868988
    // 	C108.175400,152.308090 94.377167,148.524872 80.807091,143.475830
    // 	C67.373138,138.477448 53.860413,134.828217 39.450970,138.975113
    // 	C36.600670,139.795410 33.701424,140.445648 30.410789,141.229187
    // 	C29.401018,140.946381 28.805208,140.608704 27.878124,139.916229
    // 	C27.426664,139.321320 27.237822,139.163193 26.980322,139.087051
    // 	C26.980322,139.087051 27.009119,139.029114 26.978462,139.018677
    // z"/>

    // </svg>
  ),
  logoWithText: (props: LucideProps) => (
    <Link href="/" className="">
      <span className="flex items-center justify-start">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          viewBox="0 0 500 500"
          version="1.1"
        >
          <g
            transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
            fill="currentColor"
            stroke="none"
          >
            <path
              d="M2126 4030 c-204 -413 -373 -750 -377 -750 -21 0 -1598 -231 -1621
-237 -26 -8 2 -36 572 -592 491 -477 599 -587 595 -605 -16 -68 -275 -1602
-273 -1612 2 -6 330 161 740 377 l737 387 738 -388 c406 -213 739 -384 741
-380 3 7 -261 1562 -274 1616 -4 16 108 131 594 605 567 552 599 584 574 591
-23 7 -1600 238 -1621 238 -4 0 -173 337 -377 749 -203 413 -371 750 -374 750
-3 0 -171 -337 -374 -749z m674 -291 c162 -331 300 -603 305 -605 6 -2 304
-47 664 -99 360 -52 657 -98 660 -100 3 -3 -24 -34 -59 -69 -102 -99 -895
-869 -897 -871 -2 -1 49 -300 112 -665 62 -366 113 -666 111 -667 -1 -1 -267
137 -591 307 -325 170 -597 309 -605 310 -8 0 -280 -140 -605 -310 -324 -170
-591 -308 -592 -306 -1 1 49 300 111 663 l114 661 -187 185 c-102 101 -320
314 -483 472 -164 159 -296 290 -295 291 1 1 301 46 667 99 366 53 668 100
671 103 3 4 138 276 300 605 162 328 296 597 299 597 3 0 138 -271 300 -601z"
            />
            <path
              d="M2285 3413 c-115 -234 -214 -432 -220 -440 -7 -9 -165 -36 -489 -83
-263 -39 -481 -70 -485 -70 -3 0 153 -157 347 -348 l354 -347 -82 -473 c-44
-261 -80 -478 -78 -482 2 -5 196 92 431 216 235 123 432 224 437 224 5 0 201
-101 437 -225 235 -123 429 -221 431 -216 1 5 -34 219 -78 477 -44 257 -79
473 -78 478 2 6 159 164 350 350 192 187 346 341 345 343 -2 2 -219 34 -482
73 -263 38 -482 73 -486 77 -4 4 -104 203 -223 441 -119 237 -217 432 -218
432 -2 -1 -97 -192 -213 -427z"
            />
          </g>
        </svg>

        <span className="mx-1 text-2xl font-bold">TMG</span>
      </span>
    </Link>
    //  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 500 500" version="1.1"><path d="M 135 153.620 C 135 153.999, 140.738 165.358, 147.750 178.864 C 154.762 192.369, 160.395 203.752, 160.267 204.160 C 160.138 204.567, 147.426 229.046, 132.017 258.557 C 116.607 288.068, 104 312.391, 104 312.607 C 104 312.823, 108.849 313, 114.774 313 L 125.549 313 148.524 271.328 C 161.161 248.408, 172.011 228.750, 172.635 227.642 C 173.692 225.766, 173.917 225.918, 175.933 229.869 L 178.097 234.110 156.548 273.028 C 144.697 294.432, 135 312.183, 135 312.473 C 135 312.763, 140.287 312.991, 146.750 312.981 L 158.500 312.961 173.500 283.988 C 181.750 268.053, 188.725 255.015, 189 255.015 C 189.275 255.015, 196.244 268.001, 204.487 283.873 L 219.474 312.730 228.987 313.360 C 234.219 313.706, 271.913 313.992, 312.750 313.995 C 386.335 314, 387 313.982, 387 312 C 387 310.018, 386.333 310, 314.565 310 L 242.130 310 221.446 272.750 C 210.070 252.262, 200.741 235.015, 200.715 234.423 C 200.688 233.831, 209.799 216.393, 220.960 195.673 L 241.253 158 314.126 158 C 386.333 158, 387 157.982, 387 156 C 387 153.921, 375.375 153.736, 231.750 153.519 L 219.500 153.500 204.608 182.250 C 196.418 198.063, 189.398 211, 189.010 211 C 188.622 211, 187.511 209.242, 186.543 207.094 L 184.781 203.189 197.025 179.844 C 203.759 167.005, 209.674 155.713, 210.170 154.750 C 210.998 153.140, 210.274 153, 201.138 153 L 191.206 153 182.996 167.507 C 178.480 175.486, 174.435 182.231, 174.006 182.496 C 173.577 182.762, 169.451 176.346, 164.838 168.239 L 156.450 153.500 145.725 153.216 C 139.826 153.060, 135 153.242, 135 153.620 M 261 234.467 L 261 281 274.482 281 L 287.963 281 288.232 257.943 L 288.500 234.887 297 246.928 L 305.500 258.969 314.227 258.984 L 322.954 259 331.727 246.599 L 340.500 234.197 340.768 257.599 L 341.036 281 354.518 281 L 368 281 368 234.500 L 368 188 356.706 188 L 345.412 188 329.807 210.043 L 314.201 232.086 298.800 210.293 L 283.399 188.500 272.200 188.217 L 261 187.934 261 234.467" stroke="none" fill="currentColor" fill-rule="evenodd"/></svg>
  ),
  // logo: Command,
  close: X,
  spinner: Loader2,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  trash: Trash,
  post: FileText,
  page: File,
  media: Image,
  settings: Settings,
  billing: CreditCard,
  ellipsis: MoreVertical,
  add: Plus,
  warning: AlertTriangle,
  user: User,
  arrowRight: ArrowRight,
  help: HelpCircle,
  pizza: Pizza,
  sun: SunMedium,
  moon: Moon,
  laptop: Laptop,
  gitHub: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="github"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
      ></path>
    </svg>
  ),
  twitter: Twitter,
  check: Check,
};
